<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="`${item && item.status_id === statusIdCutting ? 'Move to ISSUED' : 'Move to Cutting'}`"
    :max-width="700"
  >
    <template slot="header">
      <div
        style="width: 100%;"
        class="d-flex justify-space-between align-center pa-3"
      >
        <span
          v-if="item"
          class="f6 fw600"
        >Screen Batch# - {{ item.batch_number }}</span>
      </div>
    </template>
    <template slot="body">
      <div
        v-if="item"
        class="d-flex flex-column ga-6 pa-3 pt-0"
      >
        <div class="d-flex flex-column ga-1">
          <span class="title-span">Job</span>
          <div class="desc-div">
            <span
              class="desc-span"
              style="font-weight: bold;"
            >{{ item.job ? `${item.job.code}` : '' }}</span> - <span class="desc-span">{{ item.job && item.job.project ? item.job.project.name : '' }}</span> <span
              class="desc-span"
              style="color: #1976D2;"
            >{{ item.job ? `; ${item.job.reference}` : '' }}</span>
          </div>
        </div>

        <div class="d-flex flex-column ga-1">
          <span class="title-span">Screen Qty#</span>
          <div class="desc-div">
            <span
              class="desc-span"
              style="font-weight: bold;"
            >{{ item.screen_quantity }}</span>
          </div>
        </div>

        <!-- <div>
          <v-btn
            color="orange"
            outlined
            small
            @click="runWebhook(item)"
          >
            SCREEN BATCH QR CODE LABEL
          </v-btn>
        </div> -->
        <confirm-form ref="confirmForm" />
      </div>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as FormatHelpers from '@/helpers/FormatHelpers';
import { saveAs } from 'file-saver';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    item: null,
    statusIdNew: 1,
    statusIdMaterialAvailable: 2,
    statusIdCutting: 3,
    statusIdAssembling: 4,
    statusIdTandB: 5,
    statusIdGlazing: 6,
    statusIdFinished: 8,
    statatusIdShipping: 9,
    statatusIdReceiving: 10,
    statusIdQuarantined: 13,
    screenScheduleStatusIdInProgress: 1,
    selectedStatusId: null,
    locationId: null,
    inventoryLocationId: null,
    quarantineReasonId: null,
    quarantineSubReasonId: null,
    statuses: [],
    inventoryLocations: [],
    locations: [],
    quarantineReasons: [],
    quarantineSubReasonsAll: [],
    quarantineSubReasons: [],

  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {
    quarantineReasonId() {
      this.quarantineSubReasons = this.quarantineSubReasonsAll.filter((x) => x.reason_id === this.quarantineReasonId);
    },
  },
  created() {
    // this.getStatuses();
  },
  methods: {

    async get(qrCode) {
      this.item = null;
      this.$bus.$emit('loading');
      const res = await this.$api.screen.get(`get-screen-batch/${qrCode}`);

      if (!res || !res.id) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError', 'Screen batch not found');
        this.$refs.dialogBox.close();
        return;
      }
      this.item = res;
      if (this.item.screen_production && this.item.screen_production.status_id !== this.screenScheduleStatusIdInProgress) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError', 'Screen Production Schedule must be in current status to move screen batch');
        this.$refs.dialogBox.close();
        return;
      }
      if (this.item.status_id === this.statusIdCutting) {
        this.selectedStatusId = this.statusIdNew;
      } else if (this.item.status_id === this.statusIdFinished || this.item.status_id === this.statatusIdShipping || this.item.status_id === this.statatusIdReceiving) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError', 'Screen batch cannot be moved from its current status');
        this.$refs.dialogBox.close();
        return;
      } else {
        this.selectedStatusId = this.statusIdCutting;
      }
      this.$bus.$emit('loading');
    },

    // async getStatuses() {
    //   const res = await this.$api.screenStatus.get();
    //   this.statuses = res.filter((x) => x.id === this.statusIdMaterialAvailable || x.id === this.statusIdCutting || x.id === this.statusIdAssembling || x.id === this.statusIdTandB || x.id === this.statusIdGlazing || x.id === this.statusIdFinished || x.id === this.statusIdQuarantined);
    // },

    async submit() {
      const submitModel = {
        batch_number: this.item.batch_number,
        status_id: this.selectedStatusId,
        location_id: this.locationId,
        inventory_location_id: this.inventoryLocationId,
      };
      const res = await this.$api.screen.store(submitModel, 'update-status-batch');

      if (res.status === 510) {
        this.$bus.$emit('showError', res.message);
        return false;
      }

      if (!res) {
        this.$bus.$emit('showError', res);
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    async getLocations() {
      this.locations = await this.$api.location.getList();
      this.getInventoryLocations();
    },

    async getInventoryLocations() {
      const readModel = {
        filters: {
          finished_good_status_id: this.statusIdFinished,
          location_id: this.locationId,
        },
      };
      this.inventoryLocations = await this.$api.inventoryLocation.read(readModel);
    },
    open(qrCode) {
      if (!qrCode) return;
      this.get(qrCode);
      this.getLocations();
      this.$refs.dialogBox.open();
    },

    async runWebhook(item) {
      this.$bus.$emit('loading');

      const webhookModuleIdWindowLabels = 52;
      const webhookData = {
        module_id: webhookModuleIdWindowLabels,
        tag_id: item.tag_id,
      };

      const res = await this.$api.webhook.store(webhookData, 'run-download', { responseType: 'blob' });
      if (!res) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading');
        return;
      }

      const now = FormatHelpers.getFileTimestamp();
      const label = item.tag_id.replace(/[\s.]/g, '-');
      const fileName = `${label}_Window_Label_${now}`;

      const file = new Blob([res], {
        type: 'application/pdf',
      });
      saveAs(file, fileName);
      this.$bus.$emit('loading');
    },
  },
};
</script>

<style scoped>
.outer-div{
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

}
.title-span
{
  color: #000;
  font-size: 18px;
  font-weight: 500;
}

.desc-div
{
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 8px;
  padding-right: 8px;
  border: 1px solid #BDBDBD;
  border-radius: 6px;
  background-color: #F9F9FA;
}

.desc-span
{
  color: #000;
  font-size: 20px;
}
</style>
